import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import OrderHeader from "@widgets/pos/orders/details/order/overview/header/OrderHeader";
import NoteCard from "@widgets/pos/orders/details/order/overview/note/NoteCard";
import PaymentFulfilmentCard
    from "@widgets/pos/orders/details/order/overview/payment-fulfillment/PaymentFulfilmentCard";
import CustomerCard from "@widgets/pos/orders/details/order/overview/customer/CustomerCard";
import OrderSummaryCard from "./summary/OrderSummaryCard";

type Props = {
    order: PlacedOrderOverview,
};

const Overview = ({order}: Props) => {
    return (
        <div className={"flex-1 min-h-0 overflow-y-auto p-6"}>
            <OrderHeader order={order}/>

            <div className={"mt-8 w-full grid grid-cols-3 gap-8 items-start"}>
                <CustomerCard order={order}/>
                <PaymentFulfilmentCard order={order}/>
                <NoteCard order={order}/>
                <OrderSummaryCard order={order}/>
            </div>
        </div>
    );
};

export default Overview;